
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kamion",
      function () {
        return require("private-next-pages/kamion.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kamion"])
      });
    }
  